import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getConfigOption } from "../../store/selectors/selector.configOptions.jsx";
import { getProjectById } from "../../store/selectors/selector.projects.jsx";
import Angie from "../../utils/angie.jsx";

const ProjectName = ({ id, passedProject = {} }) => {
  const showProjectNumber = useSelector((state) => getConfigOption(state, `show_project_id`));
  const stateProject = useSelector((state) => getProjectById(state, id));
  const project = id ? stateProject : passedProject;

  if (!project) {
    Angie.logger.info(`Received project id that it doesn't exist: ${id}`, {
      id,
    });
    return "";
  }
  return showProjectNumber ? `#${project.project_number}: ${project.name}` : `${project.name}`;
};

ProjectName.propTypes = {
  id: PropTypes.number,
  passedProject: PropTypes.object,
};

export default ProjectName;
